import { Alert, Badge, Card, Space } from 'antd';
import React from 'react';
import { VerticalTicker } from "react-infinite-ticker";
import { useNavigate } from 'react-router-dom';

const NoticeBoard = ({ title, notices }) => {
    const navigate = useNavigate();

    return (
        <Card title={title} headStyle={{ textAlign: "center", background: "#0d6efd", fontSize: 20 }} bodyStyle={{ maxHeight: 326 }} className='card-border notice-board'>
            <div style={{ height: "285px" }}>
                <VerticalTicker className="notice-board" duration={15000}>
                    <Space direction='vertical' size={8} style={{ width: "100%", paddingTop: 8 }}>
                        {notices.map((element, index) =>
                            <Alert style={{ paddingBottom: 15, cursor: "pointer" }} key={element.id} message={element.text}
                                icon={<Badge count={index + 1} color='#0d6efd' />} showIcon={true} type="info"
                                onClick={() => navigate('/notice', { state: { notice: element } })} />)}
                    </Space>
                </VerticalTicker>
            </div>
        </Card>
    );
}

export default NoticeBoard;